import modelImage1 from '../assets/images/IMG_2564.jpg';
import modelImage2 from '../assets/images/IMG_2544.jpg';
import modelImage3 from '../assets/images/IMG_2540.jpg';
import navajitasFront from '../assets/images/navajitas_front.png';
import navajitasBack from '../assets/images/navajitas_back.png';
import navajitasBackGallery from '../assets/images/navajitas-back.png';
import navajitasFrontGallery from '../assets/images/navajitas-front.png';
import mesiasBack from '../assets/images/Foirola_Mesias_back.png';
import mesiasFront from '../assets/images/Foirola_Mesias_front.png';
import mesiasLogoFront from '../assets/images/mesias_front.png';
import mesiasLogoBack from '../assets/images/mesias_back.png';
import renderMesias from '../assets/videos/renderMesias.mp4';
import renderNavajitas from '../assets/videos/renderNavajitas.mp4';

export const products = [
    {
        id: 'el-mesias',
        title: 'El Mesías',
        subtitle: 'Edición Limitada',
        price: 30,
        description: 'Muy pronto viene el fin de la cosa... El día de juicio está cercando. Una pieza de declaración que trasciende la moda. Celebra la cultura local de Fuengirola con un diseño que desafía lo convencional.',
        details: [
            '100% Algodón Premium',
            'Impresión de Alta Calidad en España',
            'Corte Oversize Contemporáneo',
            'Edición Numerada'
        ],
        translations: {
            en: {
                title: 'The Messiah',
                subtitle: 'Limited Edition',
                description: 'The end of the thing is coming soon... Judgment day is approaching. A statement piece that transcends fashion. Celebrate Fuengirola\'s local culture with a design that defies convention.',
                details: [
                    '100% Premium Cotton',
                    'High Quality Printing in Spain',
                    'Contemporary Oversize Cut',
                    'Numbered Edition'
                ]
            }
        },
        images: [
            { src: mesiasBack, alt: "Trasera de la camiseta El Mesías" },
            { src: mesiasFront, alt: "Frontal de la camiseta El Mesías" },
            { src: modelImage2, alt: "Modelo con la camiseta El Mesías" },
            { src: modelImage3, alt: "Modelo con la camiseta El Mesías" },
            { src: modelImage1, alt: "Modelo con la camiseta El Mesías" }
        ],
        gridImage: mesiasBack,
        heroAsset: {
            type: 'video',
            src: renderMesias
        },
        sizes: ['S', 'M', 'L'],
        theme: {
            text: 'text-off-white',
            bg: 'bg-black/20'
        }
    },
    {
        id: 'navajitas',
        title: 'Navajitas',
        subtitle: 'Nueva Colección 2025',
        price: 30,
        description: '¿Quien no se ha echado unas navajitas de colegueo? Deporte comun en la costa del sol. Esta camisa representa una de las costumbres más miticas de nuestra tierra y es una llamada a no perder las buenas costumbres.',
        details: [
            '100% Algodón Premium',
            'Impresión de Alta Calidad en España',
            'Corte Oversize Contemporáneo',
            'Edición Numerada'
        ],
        translations: {
            en: {
                title: 'Navajitas',
                subtitle: 'New Collection 2025',
                description: 'Who hasn\'t played some "navajitas" with friends? A common sport on the Costa del Sol. This shirt represents one of the most mythical customs of our land and is a call not to lose good habits.',
                details: [
                    '100% Premium Cotton',
                    'High Quality Printing in Spain',
                    'Contemporary Oversize Cut',
                    'Numbered Edition'
                ]
            }
        },
        images: [
            { src: navajitasBackGallery, alt: "Frontal de la camiseta Navajitas" },
            { src: navajitasFrontGallery, alt: "Trasera de la camiseta Navajitas" }
        ],
        heroAsset: {
            type: 'video',
            src: renderNavajitas
        },
        sizes: ['S', 'M', 'L'],
        theme: {
            text: 'text-off-white',
            bg: 'bg-black/20'
        }
    }
];
